import { gql } from "@/services/httpAdapter";

// Common Fragments
import {
	AddedCompensationFragment,
	CallActivityPerformanceFragment,
	ChargebacksFragment,
	CompensationFragment,
	EmployeeFragment,
	LongevityFragment,
	ReviewFragment,
	TechnicianSpiffsFragment,
} from "@/Washouts/api/common/fragments";
import { AdvisorsStoreMetricsFragment, PerformanceFragment } from "./fragments";

export function getOnCreateAdvisorsWashout() {
	return gql`
		subscription onNewAdvisorsWashoutAvailable($commissionCycleId: String, $payPeriodId: String, $userId: String) {
			onNewAdvisorsWashoutAvailable(commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId, userId: $userId) {
				_id
				userId
				commissionCycleId
				payPeriodId
				created
				employee {
					...Employee
				}
				spiffs {
					...Spiffs
				}
				longevity {
					...Longevity
				}
				review {
					...Review
				}
				performance {
					...Performance
				}
				callActivityPerformance {
					...WashoutCallActivityPerformance
				}
				storeMetrics {
					...AdvisorsStoreMetrics
				}
				addedCompensations {
					...AddedCompensation
				}
				summary {
					...Compensation
				}
				chargebacks {
					...Chargebacks
				}
				effectiveLaborRate
				averageHoursPerRepairOrder
				followUpPerformance {
					averageTimeSinceLastContact
					averageClosedRepairOrdersPerDay
				}
			}
		}
		${AddedCompensationFragment}
		${AdvisorsStoreMetricsFragment}
		${CallActivityPerformanceFragment}
		${ChargebacksFragment}
		${CompensationFragment}
		${EmployeeFragment}
		${LongevityFragment}
		${PerformanceFragment}
		${ReviewFragment}
		${TechnicianSpiffsFragment}
	`;
}

export const getOnUpdateAdvisorsWashout = () => {
	return gql`
		subscription onUpdateAdvisorsWashout($commissionCycleId: String, $payPeriodId: String, $userId: String) {
			onUpdateAdvisorsWashout(commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId, userId: $userId) {
				_id
				commissionCycleId
				payPeriodId
				userId
				review {
					...Review
				}
				addedCompensations {
					...AddedCompensation
				}
				summary {
					...Compensation
				}
			}
		}
		${AddedCompensationFragment}
		${CompensationFragment}
		${ReviewFragment}
	`;
};

export function getOnUpdateAdvisorsWashoutStatus() {
	return gql`
		subscription onUpdateAdvisorsWashoutStatus($commissionCycleId: String) {
			onUpdateAdvisorsWashoutStatus(commissionCycleId: $commissionCycleId) {
				_id
				commissionCycleId
				payPeriodId
				userId
				position
				status
				employee {
					position
				}
				review {
					...Review
				}
			}
		}
		${ReviewFragment}
	`;
}
